/**
 * RefreshButton Component
 * 
 * Button to manually refresh all dashboard data by triggering React Query refetch.
 * Shows loading spinner while refreshing.
 */

import React from 'react';
import { typography, interactive } from '../../design-system/tokens';

const RefreshButton = ({ onRefresh, isRefreshing }) => {
  return (
    <button
      onClick={onRefresh}
      disabled={isRefreshing}
      className={`
        ${interactive.primaryBg}
        ${interactive.primaryHover}
        ${interactive.primaryText}
        ${typography.button}
        px-4 py-2 rounded-lg
        flex items-center gap-2
        transition-all duration-200
        disabled:opacity-50 disabled:cursor-not-allowed
        shadow-sm hover:shadow-md
      `}
    >
      {/* Icon */}
      <svg
        className={`w-4 h-4 ${isRefreshing ? 'animate-spin' : ''}`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        />
      </svg>
      
      {/* Text */}
      <span>{isRefreshing ? 'Refreshing...' : 'Refresh Data'}</span>
    </button>
  );
};

export default RefreshButton;

